<template>
  <div class="container-fluid">
    <div class="row">
      <article
        id="accessibility-wrapper"
        class="col-sm-12 col-md-10 col-lg-6 offset-md-1 offset-lg-3 wrapper"
      >
        <div
          v-if="
            (!userData || userData?.user?.launchType !== 'lti') &&
            showBackButton
          "
        >
          <back-button />
        </div>
        <div class="main-content" tabindex="-1">
          <h1 class="accessibility">
            {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_TITLE') }}
          </h1>
          <p class="description">
            {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_DESCRIPTION_1') }}
            <a
              href="https://www.w3.org/TR/WCAG22/"
              target="_blank"
              rel="noopener noreferrer"
              qid="accessibility-1"
              >{{
                $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_DESCRIPTION_2')
              }}</a
            >{{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_DESCRIPTION_3') }}
          </p>
          <p class="description">
            {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_DESCRIPTION_4') }}
          </p>

          <section>
            <h2 class="sub-heading">
              {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE') }}
            </h2>
            <p class="description">
              {{
                $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_DESCRIPTION')
              }}
            </p>
            <ul class="bulletList">
              <li class="description">
                {{
                  $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_1.PART_1')
                }}
                <strong>
                  {{
                    $t(
                      'ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_1.STRONG_TEXT'
                    )
                  }}
                </strong>
                <ul class="bulletList listStyle">
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_1_1')
                    }}
                  </li>
                </ul>
              </li>
              <li class="description">
                {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_2') }}
                <ul class="bulletList listStyle">
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_2_1')
                    }}
                  </li>
                </ul>
              </li>
              <li class="description">
                {{
                  $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3.PART_1')
                }}
                <strong>
                  {{
                    $t(
                      'ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3.STRONG_TEXT'
                    )
                  }}
                </strong>
                <ul class="bulletList listStyle">
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3_1')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3_2')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3_3')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_3_4')
                    }}
                  </li>
                </ul>
              </li>
              <li class="description">
                {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_4') }}
                <ul class="bulletList listStyle">
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_4_1')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_4_2')
                    }}
                  </li>
                </ul>
              </li>
              <li class="description">
                {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_5') }}
                <ul class="bulletList listStyle">
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_5_1')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_5_2')
                    }}
                  </li>
                  <li class="description">
                    {{
                      $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_5_3')
                    }}
                  </li>
                </ul>
              </li>
              <li class="desscription">
                {{ $t('ONBOARDING.ACCESSIBILITY.ACCESSIBILITY_FEATURE_6') }}
              </li>
            </ul>
          </section>
          <section>
            <h2 class="sub-heading">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_ACCESSIBLE') }}
            </h2>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_ACCESSIBLE_DESCRIPTION') }}
            </p>
            <ul class="bulletList">
              <li class="description">
                {{ $t('ONBOARDING.ACCESSIBILITY.HOW_ACCESSIBLE_WORKING_1') }}
              </li>
              <li class="description">
                {{ $t('ONBOARDING.ACCESSIBILITY.HOW_ACCESSIBLE_WORKING_2') }}
              </li>
            </ul>
          </section>
          <section>
            <h2 class="sub-heading">
              {{ $t('ONBOARDING.ACCESSIBILITY.FEEDBACK_CONTACT_INFO') }}
            </h2>
            <p class="description">
              {{
                $t(
                  'ONBOARDING.ACCESSIBILITY.FEEDBACK_CONTACT_INFO_DESCRIPTION_1'
                )
              }}
              <a
                href="https://cambridgeonehelp.cambridge.org/hc/en-gb/requests/new"
                target="_blank"
                rel="noopener noreferrer"
                qid="accessibility-1"
                >{{
                  $t(
                    'ONBOARDING.ACCESSIBILITY.FEEDBACK_CONTACT_INFO_DESCRIPTION_2'
                  )
                }}</a
              >{{
                $t(
                  'ONBOARDING.ACCESSIBILITY.FEEDBACK_CONTACT_INFO_DESCRIPTION_3'
                )
              }}
            </p>
            <p class="description">
              {{
                $t(
                  'ONBOARDING.ACCESSIBILITY.FEEDBACK_CONTACT_INFO_DESCRIPTION_4'
                )
              }}
            </p>
          </section>
          <section>
            <h2 class="sub-heading">
              {{ $t('ONBOARDING.ACCESSIBILITY.TECHNICAL_INFO') }}
            </h2>
            <h3 class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.BROWSER') }}
            </h3>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.BROWSER_DESCRIPTION_1') }}
            </p>
            <h3 class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.MOBILE') }}
            </h3>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.MOBILE_DESCRIPTION_1') }}
            </p>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.MOBILE_DESCRIPTION_2') }}
            </p>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.MOBILE_DESCRIPTION_3')
              }}<a
                href="https://www.w3.org/TR/WCAG22/"
                target="_blank"
                rel="noopener noreferrer"
                qid="accessibility-1"
                >{{ $t('ONBOARDING.ACCESSIBILITY.MOBILE_DESCRIPTION_4') }}</a
              >{{ $t('ONBOARDING.ACCESSIBILITY.MOBILE_DESCRIPTION_5') }}
            </p>
            <h3 class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.REQUESTS_IMPAIRED') }}
            </h3>
            <p class="description">
              {{
                $t('ONBOARDING.ACCESSIBILITY.REQUESTS_IMPAIRED_DESCRIPTION_1')
              }}
            </p>
            <p class="description">
              <a
                href="https://www.cambridge.org/rights-and-permissions/accessible-formats"
                target="_blank"
                rel="noopener noreferrer"
                qid="accessibility-1"
                >{{
                  $t('ONBOARDING.ACCESSIBILITY.REQUESTS_IMPAIRED_DESCRIPTION_2')
                }}</a
              >
            </p>
            <h3 class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.VPAT') }}
            </h3>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.VPAT_DESCRIPTION_1') }}
            </p>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.VPAT_DESCRIPTION_2') }}
              <a
                href="https://cambridgeonehelp.cambridge.org/hc/en-gb/requests/new"
                target="_blank"
                rel="noopener noreferrer"
                qid="accessibility-1"
                >{{ $t('ONBOARDING.ACCESSIBILITY.VPAT_DESCRIPTION_3') }}</a
              >{{ $t('ONBOARDING.ACCESSIBILITY.VPAT_DESCRIPTION_4') }}
            </p>
          </section>
          <section>
            <h2 class="sub-heading">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST') }}
            </h2>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST_DESCRIPTION_1') }}
            </p>
            <em class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST_DESCRIPTION_2') }}
            </em>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST_DESCRIPTION_3') }}
            </p>
            <p class="description">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST_DESCRIPTION_4') }}
            </p>
            <em class="description strong">
              {{ $t('ONBOARDING.ACCESSIBILITY.HOW_TEST_DESCRIPTION_5') }}
            </em>
          </section>
        </div>
      </article>
    </div>
  </div>
</template>
<script setup>
const { hideLoader } = useLoaderService();
const userData = ref();

definePageMeta({
  layout: 'info-layout',
  middleware: ['common-loader']
});

onBeforeMount(() => {
  hideLoader();
});
onMounted(async () => {
  document.body.focus();
  const { isUserAuthenticated } = useAuthService();
  userData.value = await isUserAuthenticated();
});

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: false
  }
});
</script>
<style lang="scss" scoped>
@import '../assets/scss/helper.scss';
.container-fluid {
  min-height: 100vh;
  .wrapper {
    padding-top: 34px;
    padding-right: 15px;
    padding-left: 15px;
    .main-content:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
    @include media-breakpoint-up(md) {
      max-width: 83.33%;
      margin-left: 8.3%;
    }

    @include media-breakpoint-up(lg) {
      max-width: 50%;
      margin-left: 25%;
    }

    h1,
    h2,
    p {
      color: var(--cup-general-color-5);
    }

    h3 {
      color: var(--cup-general-color-5);
      margin: 0;
    }

    .accessibility {
      font-size: 32px;
      font-weight: 300;
      line-height: 40px;
      text-align: center;

      @include media-breakpoint-up(sm) {
        font-size: 40px;
        line-height: 48px;
      }

      @include media-breakpoint-up(lg) {
        font-size: 48px;
        line-height: 56px;
        font-weight: 200;
      }
    }

    .last-updated {
      color: var(--cup-general-color-4);
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
    }

    .sub-heading {
      font-size: 18px;
      font-weight: 800;
      line-height: 24px;
      padding-bottom: 18px;
      padding-top: 0;
      margin-bottom: 0;
    }

    .description {
      font-size: 14px;
      line-height: 20px;

      @include media-breakpoint-up(sm) {
        font-size: 16px;
        line-height: 24px;
      }

      padding-bottom: 7px;

      &.strong {
        font-weight: 700;
      }
    }

    a {
      color: var(--cup-main-color-1);
    }

    em {
      display: block;
      margin-bottom: 16px;
      padding-bottom: 7px;
    }

    .listStyle {
      list-style-type: circle;
    }
  }
}
</style>
